<template>
	<div class="bottom">
		<div class="top">
			<div class="lflogo iconfont">&#xe613;</div>
			<div v-for="item in BsTitle" :key="item" class="title-style">
				<div class="icon iconfont">&#xe600;</div>
				<div class="BStitle">{{item}}</div>
			</div>
		</div> 
		
		<div v-for="(itmes,index) in this.ulliAry">
			<div class="listbox">
				<div class="list">{{itmes.name}}</div>
				<div class="button iconfont" @click="dropdown(index)" :style="itmes.defaultstyle">&#xe677;</div>
				<div class="list-ulli animated fadeInDown" v-for="(item,index) in itmes.ulli" :style="item.class" v-if="itmes.dropflag==true" @click="tomode(item.link,item.bottom)">
					{{item.write}}
				</div>
			</div>
		</div>
		
		<div style="display: flex; width: 95%;margin:0 auto">
		<div class="infoshell" >
		<div class="telephone">服务热线:<a :href="'tel:' + Phone" class="text">{{Phone}}</a></div>
		<div class="time">北京时间：周一至周日 09:00－18:00</div>
		</div>
		<div class="imageshell">
		<div class="weibo" @click="openWeibo"><img :src="weiboimg"></div>
		<div class="weixin" @click="openWeiXin"><img :src="weixinimg"></div>
		</div>
		</div>
		<div class="email">{{addDate()}}</div>
		<div class="info1">厦门乐范健康科技有限公司 ｜ 闽ICP备17007620号</div>
		<div class="info2"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602001128">闽公网安备 35020602001128号</a>｜Designed by LF UEDC</div>
		
	</div>
</template>

<script>
	export default {
		name: 'bottom',
		props: {
			BsTitle: {
				type: Array,
				default () {
					return []
				}
			}
		},
		methods: {
			tomode(url,e) {
				console.log('url',url,e);
				if(url.indexOf(":") != -1){
					window.open(url, '_self');
				}else{
					let routeUrl = this.$router.resolve({
						path: url,
						query: {
							bottomname: e
						}
					});
					window.open(routeUrl.href, '_self');
				}
				
				
			},
			dropdown(index) {
				let that = this;
				console.log(index);
				if(index == 0){
					if (that.dropflag1 == false) {
						that.defaultstyle1 = 'animation: cuIcon-spin1 0.3s  linear;animation-fill-mode : forwards;'
						that.dropflag1 = true
					} else {
						that.defaultstyle1 = 'animation: cuIcon-spin2 0.3s  linear;animation-fill-mode : none;'
						that.dropflag1 = false
					}
					that.defaultstyle2 = 'animation: cuIcon-spin2 0.3s  linear;animation-fill-mode : none;'
					that.dropflag2 = false
					that.defaultstyle3 = 'animation: cuIcon-spin2 0.3s  linear;animation-fill-mode : none;'
					that.dropflag3 = false
				}else if(index == 1){
					if (that.dropflag2 == false) {
						that.defaultstyle2 = 'animation: cuIcon-spin1 0.3s  linear;animation-fill-mode : forwards;'
						that.dropflag2 = true
					
					} else {
						that.defaultstyle2 = 'animation: cuIcon-spin2 0.3s  linear;animation-fill-mode : none;'
						that.dropflag2 = false
					}
					that.defaultstyle1 = 'animation: cuIcon-spin2 0.3s  linear;animation-fill-mode : none;'
					that.dropflag1 = false
					that.defaultstyle3 = 'animation: cuIcon-spin2 0.3s  linear;animation-fill-mode : none;'
					that.dropflag3 = false
				}else{
					if (that.dropflag3 == false) {
						that.defaultstyle3 = 'animation: cuIcon-spin1 0.3s  linear;animation-fill-mode : forwards;'
						that.dropflag3 = true
					
					} else {
						that.defaultstyle3 = 'animation: cuIcon-spin2 0.3s  linear;animation-fill-mode : none;'
						that.dropflag3 = false
					}
					that.defaultstyle1 = 'animation: cuIcon-spin2 0.3s  linear;animation-fill-mode : none;'
					that.dropflag1 = false
					that.defaultstyle2 = 'animation: cuIcon-spin2 0.3s  linear;animation-fill-mode : none;'
					that.dropflag2 = false
				}
				
			},
			openWeibo(){
				window.open('https://weibo.com/leravan?is_hot=1','_self')
			},
			openWeiXin(){
				
				window.open('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUyMzg3NzQ4MQ==&scene=110==#wechat_redirect','_self')
			},
			addDate() {
				let nowDate = new Date();
				let date = {
					year: nowDate.getFullYear(),
					month: nowDate.getMonth() + 1,
					date: nowDate.getDate(),
				}
				console.log('date,',nowDate);
				let systemDate = date.year;
				return 'Copyright © 2016 - '+ systemDate + ' Lefan inc.保留所有权利。';
			}
		},
		data() {
			return {
				dropflag1: false,
				dropflag2: false,
				dropflag3: false,
				defaultstyle1: '',
				defaultstyle2: '',
				defaultstyle3: '',
				weiboimg:this.GLOBAL.imgHost + '/images/weibo.png',
				weixinimg:this.GLOBAL.imgHost + '/images/weixin.png',
				Phone:'400-101-8969',
			}
		},
		computed:{
			
			ulliAry(){
				let uiliAry = [
					{
						name:'适用场景',
						ulli:[{
								write:'办公室新姿势',
								link:'/product',
								bottom:'office',
								class:''
							},{
								write:'出行更轻松',
								link:'/product',
								bottom:'travel',
								class:''
							},{
								write:'生活更舒适',
								link:'/product',
								bottom:'life',
								class:'margin-bottom:10px'
							},],
						defaultstyle: this.defaultstyle1,
						dropflag:this.dropflag1,
					},{
						name:'官方网站',
						ulli:[{
								write:'天猫旗舰店',
								link:'https://leravan.tmall.com/?spm=a1z10.3-b-s.w5001-21792119858.2.2f825759flC96i',
								class:''
							},{
								write:'京东旗舰店',
								link:'https://mall.jd.com/index-715012.html',
								class:''
							},{
								write:'小米有品',
								link:'https://www.xiaomiyoupin.com/search?keyword=乐范',
								class:'margin-bottom:10px'
							},],
						defaultstyle: this.defaultstyle2,
						dropflag:this.dropflag2,
					},{
						name:'线下渠道',
						ulli:[{
							write:'线下销售',
							link:'Shop',
							bottom:'xxxs',
							class:''
						},{
							write:'招商信息',
							link:'Shop',
							bottom:'zsxx',
							class:'margin-bottom:10px'
						}],
						defaultstyle: this.defaultstyle3,
						dropflag:this.dropflag3,
					}
				]
				return uiliAry;
			}
			
			
		}
	}
</script>

<style>
	@font-face {
		font-family: 'iconfont';
		/* project id 1631181 */
		src: url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.eot');
		src: url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.eot?#iefix') format('embedded-opentype'),
			url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.woff2') format('woff2'),
			url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.woff') format('woff'),
			url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.ttf') format('truetype'),
			url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.svg#iconfont') format('svg');
	}

	@keyframes cuIcon-spin1 {
		0% {

			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
			/* top: 0rem; */
		}


		100% {
			-webkit-transform: rotate(45deg);
			transform: rotate(45deg);
			/* top: 0.325rem; */
		}
	}

	@keyframes cuIcon-spin2 {
		0% {
			-webkit-transform: rotate(45deg);
			transform: rotate(45deg);
			/* top: 0rem; */
		}

		100% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
			/* top: -0.325rem; */
		}
	}

	@keyframes cuIcon-spin3 {
		0% {
			-webkit-transform: rotate(40deg);
			transform: rotate(40deg);
			top: 0.325rem;
		}

		100% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
	}

	@keyframes cuIcon-spin4 {
		0% {
			-webkit-transform: rotate(-45deg);
			transform: rotate(-45deg);
			top: -0.325rem;
		}

		100% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
	}

	.iconfont {
		font-family: 'iconfont';
	}

	.bottom {
		z-index: 777;
		/* position: relative;
		max-width: 33.75rem; */
		/* height: 27rem; */
		background-color: #121212;
		margin: 0 auto;
	}

	.bottom .top {
		display: flex;
		width: 18.75rem;
		padding-left: 0.875rem;
		padding-top: 4.5rem;
	}

	.bottom .top .lflogo {
		width: 2rem;
		float: left;
		font-size: 1rem;
		padding-top: 2px;
		color: rgba(255, 255, 255, 1);
	}
	.bottom .top .title-style{
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
	.bottom .top .title-style .icon {
		width: 1rem;
	    padding-top: 3px;
		float: left;
		font-size: 1rem;
		height: 1.75rem;
		text-align: center;
		align-items: center;
		color: rgba(255, 255, 255, 1);
	}

	.bottom .top .title-style .BStitle {
		float: left;
		color: white;
		font-family: Alibaba PuHuiTi;
		font-weight: 200;
		color: rgba(255, 255, 255, 1);
		font-size: 0.9rem;
		padding-bottom: 11px;
	}

	.bottom .list {
		width: 50%;
		color: white;
		clear: both;
		text-align: left;
		margin: 0 auto;
		font-weight: 400;
		font-size: 0.8rem;
		float: left;
	}

	.listbox {
		clear: both;
		width: 85%;
		overflow-x: hidden;
		/* height: 100%; */
		/* border-top: 0.0625rem solid #3E3E3E; */
		border-bottom: 0.0625rem solid #3E3E3E;
		margin: 0 auto;
		padding-top: 0.7rem;
		/* padding-bottom: 1.5rem; */
	}

	.bottom .listbox .list-ulli {
		width: 90%;
		height: 2.125rem;
		line-height: 2.125rem;
		color: white;
		clear: both;
		text-align: left;
		margin: 0 auto;
		font-weight: 200;
		font-size: 0.75rem;
		
	}
	.bottom .listbox .list-ulli a{
		text-decoration: none;
		font-weight: 200;
		font-size: 0.75rem;
		color: white;
		
	}
	.button {
		/* width: 40%; */
		float: left;
		position: relative;
		left: 42%;
		/* padding-top: 3%; */
		color: white;
		top: -4px;
		font-size: 1.625rem;
		/* top: 35%; */
	}

	.line1 {
		width: 1rem;
		height: 0.15rem;
		background: white;
		border-radius: 0.1875rem;
		position: relative;
		top: 0;
		z-index: 1;
	}

	.line2 {
		width: 1rem;
		height: 0.15rem;
		background: white;
		border-radius: 0.1875rem;
		margin-top: 0.5rem;
		position: relative;
		top: -0.625rem;
		z-index: 1;
	}
	.infoshell{
		width: 70%;
	}
	.telephone {
		clear: both;
		width: 85%;
		/* height: 1.3rem; */
		font-size: 0.8rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 200;
		color: rgba(84, 84, 84, 1);
		line-height: 1.3rem;
		/* border: 1px solid red; */
		margin: 0 auto;
		text-align: left;
		margin-top: 5%;
	}

	.telephone .text {
		color: #2CA5FF;
		clear: both;
		display: inline;
	}
	.time{
		clear: both;
		width: 85%;
		height: 1.3rem;
		font-size: 0.8rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 200;
		color: rgba(84, 84, 84, 1);
		line-height: 1.3rem;
		/* border: 1px solid red; */
		margin: 0 auto;
		text-align: left;
	}
	.imageshell{
		width: 20%;
		display: flex;
		padding-top: 0.625rem;
	}
	.weibo{
		width: 2rem;
		position:relative;
		/* left: 70%; */
		/* margin-top: -10%; */
	}
	.weibo img{
		width: 2rem;
	}
	.weixin{
		width: 2rem;
		position:relative;
		margin-left: 15%;
		/* left: 83%; */
		/* margin-top: -10%; */
	}
	.weixin img{
		width: 2rem;
	}
	.email{
		width:85%;
		height:4rem;
		font-size:0.8rem;
		font-family:Alibaba PuHuiTi;
		font-weight:400;
		color:rgba(136,136,136,1);
		line-height:4rem;
		margin: 0 auto;
		text-align: left;
		
	}
	.info1{
		width:85%;
		/* height:3rem; */
		font-size:0.75rem;
		font-family:Alibaba PuHuiTi;
		font-weight:400;
		color:rgba(136,136,136,1);
		/* line-height:3rem; */
		margin: 0 auto;
		text-align: left;
	}
	.info2{
		flex-direction: row;
		width:85%;
		height:3rem; 
		font-size:0.75rem;
		font-family:Alibaba PuHuiTi;
		font-weight:400;
		color:rgba(136,136,136,1);
		line-height:1rem;
		margin: 0 auto;
		text-align: left;
	}
	.info2 a {
		color: rgba(136,136,136,1);
		border-bottom: #797979 solid 1px;
	}
</style>


<!-- <div class="shell" style="margin-top: 1.5rem;" >
			<div class="listbox">
				<div class="list">适用场景</div>
				<div class="button iconfont" @click="dropdown1" :style="defaultstyle1">&#xe677;</div>
				<div class="list-ulli animated fadeInDown" v-for="item in ulli1" v-if="dropflag1==true"  @click="tomode(item.link)">
					{{item.write}}
				</div>
			</div>
		</div>
		<div class="listbox">
			<div class="list">官方网站</div>
			<div class="button iconfont" @click="dropdown2" :style="defaultstyle2">&#xe677;</div>
			<div class="list-ulli animated fadeInDown" v-for="item in ulli2" v-if="dropflag2==true">
				<a :href="item.url"  class="href" target=_self>{{item.name}}</a>
			</div>
		</div>

		<div class="listbox">
			<div class="list">线下渠道</div>
			<div class="button iconfont" @click="dropdown3" :style="defaultstyle3">&#xe677;</div>
			<div class="list-ulli animated fadeInDown" v-for="item in ulli3" v-if="dropflag3==true">
				{{item}}
			</div>
		</div> -->